module.exports = __webpack_public_path__ + "static/about2-83bd5e58b56b447426acb498f0fad56c.jpg";